import { render, staticRenderFns } from "./TabelaNaoEnviadasCertificacao.vue?vue&type=template&id=415b1940&lang=pug"
import script from "./TabelaNaoEnviadasCertificacao.vue?vue&type=script&lang=js"
export * from "./TabelaNaoEnviadasCertificacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaNaoEnviadasCertificacao.vue?vue&type=style&index=0&id=415b1940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports